'use strict';

(function(window) {

  var careersSearch = {
    // Get all careers search forms
    init: function() {
      const careersSearchEl = document.getElementsByClassName('CareersSearch');
      if (!careersSearchEl.length) {
        return;
      }

      this.eachSearch(careersSearchEl);
    },
    // For each search send to careers search site using search value
    eachSearch: function(searches) {
      for (let search of searches) {
        search.onsubmit = function(e) {
          const searchUrl = 'http://jobs.thomsonreuters.com/ListJobs/ByKeyword/';
          const searchVal = search.getElementsByClassName('CareersSearch-input')[0].value;

          if(searchVal) {
            window.open(encodeURI(searchUrl + searchVal));
          } else {
            e.preventDefault();
          }

        }
      }
    }
  };

  (function() {
    careersSearch.init();
  })();

})(window);



// WEBPACK FOOTER //
// ./js/careers-search.js